/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import { ReviewRating } from "@quintype/components";
import { CustomLink } from "../custom-link";
import PropTypes from "prop-types";
import { Author } from "./author.js";
import { CollectionName } from "./collection-name.js";
import { isExternalStory, getStoryUrl } from "../../utils";

function StoryList(props) {
  return !props.stories ? null : (
    <div className="story-list">
      {props.stories.map((storyObj, index) => {
        // The `props.story` can be an item from items of a collection or a story itself.
        // assigning it accordinlgy.
        const story = storyObj && storyObj.type === "story" && storyObj.story ? storyObj.story : storyObj;
        return story && <StoryListItem story={story} key={index} config={props.config} />;
      })}
    </div>
  );
}
StoryList.propTypes = {
  stories: PropTypes.array,
  config: PropTypes.object
};

function StoryListItem({ story, config }) {
  const author = {
    name: get(story, ["authors", 0, "name"], story["author-name"]),
    id: get(story, ["authors", 0, "id"], story["author-id"])
  };
  const isReviewStory = story["story-template"] === "review";

  return (
    <CustomLink href={getStoryUrl(story)} externalLink={isExternalStory(story)}>
      {config && config.section && (
        <CollectionName
          name={story.sections[0]["display-name"] || story.sections[0]["name"]}
          section={story.sections[0]}
        />
      )}
      <h2 className="story-list__heading" data-test-id="story-list-heading">
        <bdi dangerouslySetInnerHTML={{ __html: story.headline }} />
      </h2>
      {isReviewStory && <ReviewRating value={get(story, ["metadata", "review-rating", "value"], "0")} />}
      <Author config={config} author={author} />
    </CustomLink>
  );
}
StoryListItem.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};
export { StoryList };
export { StoryListItem };
